import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["repositoryName", "fetch", "accessToken", "apiEndpoint", "uri"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { getRepositoryName, getGraphQLEndpoint, getRepositoryEndpoint, createClient } from '@prismicio/client';
import { createHttpLink } from '@apollo/client/core';

var createPrismicLink = function createPrismicLink(config) {
  var providedRepositoryName = config.repositoryName,
      fetch = config.fetch,
      accessToken = config.accessToken,
      providedApiEndpoint = config.apiEndpoint,
      providedURI = config.uri,
      options = _objectWithoutProperties(config, _excluded);

  var repositoryName = providedRepositoryName;

  if (!repositoryName && providedURI) {
    repositoryName = getRepositoryName(providedURI);
  }

  if (!repositoryName) {
    throw new Error("At least one of the following options are required for createPrismicLink(): repositoryName, uri. If a repositoryName option is not given, the uri option must be a standard, non-proxied Prismic GraphQL API URL including the repository name.");
  }

  var uri = providedURI || getGraphQLEndpoint(repositoryName);
  var apiEndpoint = providedApiEndpoint || getRepositoryEndpoint(repositoryName);
  var client = createClient(apiEndpoint, {
    fetch: fetch,
    accessToken: accessToken
  });
  return createHttpLink(_objectSpread({
    uri: uri,
    fetch: client.graphQLFetch,
    useGETForQueries: true
  }, options));
};

var PrismicLink = createPrismicLink;
export { PrismicLink, createPrismicLink };